/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
    Dialog,
    DialogHeader,
    DialogContent,
    Text,
    Heading
} from '@locus-taxy/neo-ui';

import useTimeout from 'common/hooks/useTimeout';

type Props = {
    // Will timeout after delay
    delay: number,
    onTimeout: () => void
};

const SessionTimeoutDialog = ({ onTimeout, delay }: Props): React.Node => {
    const { t } = useTranslation('translations');
    useTimeout(() => {
        onTimeout();
    }, delay);

    return (
        <Dialog sticky isOpen dismissOnBackdrop={false} dismissOnEscape={false}>
            <DialogHeader>
                <Heading>{t('sessionIdleTimeout.dialog.title')}</Heading>
            </DialogHeader>
            <DialogContent>
                <Text fontSize={2}>
                    {t('sessionIdleTimeout.dialog.description')}
                </Text>
            </DialogContent>
        </Dialog>
    );
};

export default SessionTimeoutDialog;
